import { useQuery } from '@apollo/client'
import React from 'react'
import { useHistory } from 'react-router'
import { FETCH_PROCEDURES } from '../../../graphql/queries'
import theme from '../../../theme'
import BudgetAddCard from '../../Budget/BudgetAddCard'
import { useListStyles } from '../../Budget/styles'
import { Procedure } from '../../Budget/types'
import ProcedureCard from './ProcedureCard'

const ProceduresList: React.FC = () => {
  const classes = useListStyles()
  const router = useHistory()
  const { data } = useQuery<{ procedures: { edges: Procedure[] } }>(
    FETCH_PROCEDURES,
    {
      fetchPolicy: 'network-only'
    }
  )
  const procedures = data?.procedures?.edges || []
  return (
    <div className={classes.root}>
      <div className={classes.list}>
        <h1 className={classes.title}>Procedimentos Cirúrgico</h1>
        <h2 className={classes.description}>
          Escolha um procedimento cirúrgico para editar ou crie um novo
        </h2>
        <br />
        <BudgetAddCard
          title="Adicionar Procedimento"
          onClick={() => router.push('/configuracao/procedimentos/novo')}
        />
        <div className={classes.overflow}>
          {procedures.map((procedure, index) => (
            <React.Fragment key={index}>
              <ProcedureCard
                procedure={procedure}
                style={{ background: theme.palette.primary.light }}
              />
              <br />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProceduresList
